(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WinesListController', WinesListController);

	WinesListController.$inject = ['$scope', '$rootScope', 'lodash', '$mdDialog', 'userPouch', 'WineRepository', '$log', '$mdBottomSheet', 'WineTable', '$window', '$timeout', '$mdMedia', 'UserService', 'MessageService', 'DialogService', 'Utils', '$mdPanel'];

	function WinesListController($scope, $rootScope, lodash, $mdDialog, userPouch, WineRepository, $log, $mdBottomSheet, WineTable, $window, $timeout, $mdMedia, UserService, MessageService, DialogService, Utils, $mdPanel) {

		/* jshint validthis: true */
		var self = this;

		var throttledPageUpdater;

		var throttledDocUpdater;

        self.listItemActionPanel = $mdPanel;

		self.tableHeight = '300px';

		self.table = WineTable;

		self.purchasedQuantity = 1;

		self.docs = {
			synchronized: false,
			local: 0,
			remote: 0
		};

		self.printSettings = {
			"fontSize": 12,
			"bold": {
				"separators": false,
				"headings": false
			},
			"style": "custom"
		};

		self.clearFilters = clearFilters;
		self.showAlert = showAlert;
		self.edit = edit;
		self.add = add;
        self.activeFilteredWines = WineTable.filteredWines;
		self.getPercentProgress = getPercentProgress;
		self.chooseHeader = chooseHeader;
		self.orderTable = orderTable;
		self.screenIsSmall = screenIsSmall;
		self.search = search;
		self.browserPrint = browserPrint;
		self.go = Utils.go;
		self.showListItemActions = showListItemActions;

		initialize();

		/** begin methods */

		function initialize(){

			$log.debug('Wines Controller initialized');

			$mdBottomSheet.hide();

			throttledDocUpdater = lodash.throttle(updateDocCounts, 1000);

			throttledPageUpdater = lodash.throttle(updatePageFn, 5000);

			setUserPreferences();

			$($window).on('resize', function(){
				updateDataTableHeight(90);
			});

			$rootScope.$on('$viewContentLoaded', function (event, viewName) {
				if (viewName === 'subheader@'){
					updateDataTableHeight();
				}
			});

			$scope.$on('$destroy', function(){
				var document = $($window.document);

				document.off('resize');

				throttledDocUpdater.cancel();

				throttledPageUpdater.cancel();

				throttledDocUpdater = null;
				throttledPageUpdater = null;
			});

			showWines();

			userPouch.getSyncHandler().on('paused', syncCompleteHandler);

			userPouch.getSyncHandler().on('change', function(change){
                throttledDocUpdater();
			});

			// setup sync listener so it can update the data on changes
			initializeSyncListener();

			var customHeaderChangeListener = $rootScope.$on('CustomHeadersWereSet', function(){
				setUserPreferences();
			});

			$scope.$on('$destroy', customHeaderChangeListener);
		}

		function updateDataTableHeight(addHeightTweak){

			var $subheader = angular.element('#data-table-subheader:visible');

			var headerAdj = $subheader.length ? $subheader.height() : 0;

			var addHeight = lodash.isNotEmptyOrNull(addHeightTweak) ? addHeightTweak : 0;

			// 148 = height of footer and a buffer, for some reason on render it shows > 200px but it isn't
			self.tableHeight = angular.element('body').height() - angular.element('#header').height() - 148 - headerAdj + addHeight + 'px';
		}

		function updateLoading(){
			if (self.docs.remote === self.docs.local){
				WineTable.doneLoading();
			} else {
				WineTable.markLoading();
			}
		}

		function updateDocCounts() {

			$log.debug('Updating document counts...');

			updateRemoteDocCount().then(updateLocalDocCount);
		}

		function browserPrint(){
			$window.print();
		}

        /**
         * @return Promise
         */
		function updateLocalDocCount(){
			return userPouch.db().info().then(function(res) {

                $log.debug('Updating local doc count.', res);

				if (res.doc_count >= 0){

					self.docs.local = res.doc_count;

					updateLoading();
				}

			}).catch(function(err){

				$log.debug('Error getting local doc count', err);

			});
		}

		function setUserPreferences(){

			var headers = lodash.get(UserService.$localStorage, 'headers');

			var numHeaders = lodash.get(UserService.$localStorage, 'columns');

			if (numHeaders){
				// update wine table settings
				$log.debug('User wants to show this many headers:', numHeaders);
				WineTable.setNumHeaderColumns(numHeaders);
			}

			if (headers && headers.length > 0){
				$log.debug('Setting user headers to ', headers);
				WineTable.setActiveHeadersByIds(headers);
			}

			// ensure user's last order settings if they exist

			var userOrderSettings = lodash.get(UserService.$localStorage, 'order');

			if (userOrderSettings){

				$log.debug('Applying User Order Settings', userOrderSettings.column, userOrderSettings.reverse);

				self.table.settings.column = userOrderSettings.column;
				self.table.settings.reverse = userOrderSettings.reverse;
			}
		}

        /**
		 * @return Promise
         */
		function updateRemoteDocCount() {

			return userPouch.remote().info().then(function (res) {

				$log.debug('Updating remote doc count.', res);

				if (res.doc_count){

					self.docs.remote = res.doc_count;

					updateLoading();

				} else {
					WineTable.doneLoading();
				}

			}, function (err) {

				WineTable.doneLoading();

				$log.debug('Error fetching remote doc count', err);
			});
		}

		function screenIsSmall(){
			return $mdMedia('sm');
		}

		function getPercentProgress() {
			if (! self.docs.remote) {
				return 0;
			}
			if (self.docs.synchronized){
				return 100;
			}
			return Math.floor(100 * self.docs.local / self.docs.remote);
		}

		function updatePageHandler(change) {

			if (change.direction === 'pull'){

				$log.debug('Incoming change from remote...', change);

				if (lodash.isNotEmptyOrNull(throttledPageUpdater) && lodash.isFunction(throttledPageUpdater)){
					throttledPageUpdater();
				}
			}

			if (change.direction === 'push'){

				var docs = lodash.get(change, 'change.docs');

				$log.debug('Outgoing change from local...', change);

				lodash.each(docs, function(doc){

					if (doc['_deleted']){

						$log.debug('Deleting wine...', doc);

						var id = lodash.get(doc, '_id');

						WineTable.removeById(id);
					}
				});
			}
		}

		function updatePageFn() {

			$log.debug('Updating page...');

			showWines();
		}

		function doneShowingWines(){
			$log.debug('Done showing wines...');

			// We have changes coming in, ensure that doc counts are up to date.
			updateDocCounts();
		}

		function showWines(){

			$log.debug('Showing wines...');

			WineRepository.all().then(function(wineEntities){

				$log.debug('Got wines...', wineEntities.length);

				if (wineEntities.length > 0){

					$log.debug('Setting wines on table...', wineEntities.length, wineEntities[0]);

					WineTable.setWines(wineEntities);

					var winesWithThumbs = [];

					lodash.map(wineEntities, function (entity) {
						if (entity._attachments) {
							winesWithThumbs.push(entity);
						}
					});

					// now process those with thumbnails
					if (winesWithThumbs.length > 0) {
						lodash.map(winesWithThumbs, function (entity) {

							// @TODO add to service

							$log.debug('Finding thumbnail for ', entity._id);

							userPouch.db().getAttachment(entity._id, 'thumbnail.jpg')
								.then(function (blob) {
									entity.setThumbnail(URL.createObjectURL(blob));
								}).catch(function (err) {
									$log.debug('Error getting thumbnail', err);
								});
						});
					}

					doneShowingWines();
				}

			}).catch(function(){
				// we may not have any docs yet
				doneShowingWines();
				WineTable.doneLoading();
			});
		}

		/**
		 * Setup listener to show wines when we have a change.
		 */
		function initializeSyncListener(){

			$log.debug('Initializing sync / update listener...');

			userPouch.getSyncHandler()
				.on('change', updatePageHandler);
		}

		function syncCompleteHandler(){
			$log.debug('Sync Complete!');

			// Since we're doing live replication, the complete event will not trigger, so use paused instead.
			if (! self.docs.synchronized){
				self.docs.synchronized = true;
				$log.debug('Sync Complete for now. Showing wines.');
				showWines();
			}

            updateDocCounts();
		}

		function add(){
			Utils.go('wines/add');
		}

		function edit(entity){
			Utils.go('wines/edit', {id: entity['_id']});
		}

		function clearFilters(){
			WineTable.resetFilters();
		}

		function orderTable(column){

			// save column to order to user localStorage so we can persist
			UserService.$localStorage.order.column = column;

			self.table.orderTable(column);

			// scroll to top
			angular.element('.md-virtual-repeat-scroller')[0].scrollTop = 0;

			// orderTable will toggle the sort direction above, persist to localStorage
			UserService.$localStorage.order.reverse = self.table.settings.reverse;
		}

		function showAlert(content) {
			return $mdDialog.show(
				$mdDialog.alert({
					"title": "Oops",
					"content": content,
					"ok": "Got it!"
				})
			);
		}

		function chooseHeader(column){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/headers.html',
				controller: 'ChooseHeaderDialogController as dialog',
				locals: {
					column: column
				}
			});
		}

		/** @TODO abstract these guys */
		function search(){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/search.html',
				controller: 'SearchDialogController as dialog'
			});
		}

		function showListItemActions($event, wine){

            var position = this.listItemActionPanel
                .newPanelPosition()
                .relativeTo($event.currentTarget)
                .addPanelPosition(this.listItemActionPanel.xPosition.ALIGN_START, this.listItemActionPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: 'WineActionPanelController as panel',
                templateUrl: 'templates/panels/wineActions.html',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {
                    wine: wine
                },
                openFrom: $event,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 9999
            };

            this.listItemActionPanel.open(config);
        }
    }

})();
